import {
  ChangeJournalViewItemServiceComponentConfig,
  ChangeJournalViewItemServiceProvider,
  vsProviderName as ChangeJournalViewItemServiceProviderName,
  vsServiceName as ChangeJournalViewItemServiceName,
} from "../../../../records/changeJournal/changeJournalViewComponent/itemObjectDetail";
import { vsModuleName as changeJournalModule } from "../../../../records/changeJournal/module";

import {
  vsComponentName as changeJournalMachineItemViewComponentName,
  changeJournalMachineItemViewComponentOptions,
} from "./machine/component";

import {
  vsComponentName as changeJournalMachineConfigurationItemViewComponentName,
  changeJournalMachineConfigurationItemViewComponentOptions,
} from "./machineConfiguration/component";

import angular, { IPromise } from "angular";
import {
  machineConfigurationObjectName,
  machineConfigurationTypeObjectName,
  machineObjectName,
} from "../../../shared/names";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { Machine } from "../../models/machine";
import { ServiceResponse } from "../../../../records/server/query";
import { MachineConfigurationView } from "../../models/machineConfiguration";
import {
  ChangeJournalObject,
  ChangeJournalObjectIdentifier,
} from "../../../../records/changeJournal/changeJournalViewComponent/models";
import { uniqBy } from "lodash";
import { MachineConfigurationType } from "../../models/machineConfigurationType";
import {
  changeJournalMachineConfigurationTypeItemViewComponentOptions,
  vsComponentName as changeJournalMachineConfigurationTypeItemViewComponentName,
} from "./machineConfigurationType";

export const vsModuleName = "SlotTrak.Machines.Config.ChangeJournal";

angular
  .module(
    vsModuleName,
    [changeJournalModule],
    [
      ChangeJournalViewItemServiceProviderName,
      (
        changeJournalViewItemServiceProvider: ChangeJournalViewItemServiceProvider
      ) => {
        
        changeJournalViewItemServiceProvider.addTypeComponent(
          machineConfigurationTypeObjectName,
          <ChangeJournalViewItemServiceComponentConfig>{
            componentName:
              changeJournalMachineConfigurationTypeItemViewComponentName,
            resolveObjects: [
              "objectIdentifier",
              ServerUtilityName,
              ChangeJournalViewItemServiceName,
              (
                objectIdentifier: ChangeJournalObjectIdentifier,
                serverUtility: ServerUtility
              ) =>
                serverUtility
                  .getById<ServiceResponse<MachineConfigurationType>>({
                    id: objectIdentifier.ObjectId,
                    url: "/api/machines/MachineConfigurationType",
                  })
                  .then((r): ChangeJournalObject[] => [
                    {
                      id: objectIdentifier,
                      object: r.Result,
                    },
                  ]),
            ],
            resolveInfoSref: (o) => ({
              sref: "main.machines.configurationType.info.redirect",
              params: {
                id: o.id.ObjectId,
              },
            }),
          }
        );
        changeJournalViewItemServiceProvider.addTypeComponent(
          machineObjectName,
          <ChangeJournalViewItemServiceComponentConfig>{
            componentName: changeJournalMachineItemViewComponentName,
            resolveObjects: [
              "objectIdentifier",
              ServerUtilityName,
              getMachineObjects,
            ],
            resolveInfoSref: (object) => ({
              sref: "main.machines.detail.configurations",
              params: {
                machineId: object.id.ObjectId,
              },
            }),
          }
        );
        changeJournalViewItemServiceProvider.addTypeComponent(
          machineConfigurationObjectName,
          {
            componentName:
              changeJournalMachineConfigurationItemViewComponentName,
            resolveInfoSref: (object: ChangeJournalObject) => ({
              sref: "main.machines.detail.configurations",
              params: {
                machineId: object.object.MachineId,
              },
            }),
            resolveObjects: [
              "objectIdentifier",
              ServerUtilityName,
              (
                id: ChangeJournalObjectIdentifier,
                serverUtility: ServerUtility
              ) =>
                serverUtility
                  .query<MachineConfigurationView>({
                    url: "/api/machines/MachineConfiguration",
                    query: {
                      Id: id.ObjectId,
                    },
                  })
                  .then((queryResult) =>
                    getMachineObjects(
                      {
                        ObjectId: queryResult.Results[0].MachineId,
                        ObjectName: machineObjectName,
                      },
                      serverUtility
                    )
                  ),
            ],
          }
        );
      },
    ]
  )
  .component(
    changeJournalMachineItemViewComponentName,
    changeJournalMachineItemViewComponentOptions
  )
  .component(
    changeJournalMachineConfigurationItemViewComponentName,
    changeJournalMachineConfigurationItemViewComponentOptions
  )
  .component(
    changeJournalMachineConfigurationTypeItemViewComponentName,
    changeJournalMachineConfigurationTypeItemViewComponentOptions
  );

function getMachineObjects(
  changeJournalObjectIdentifier: ChangeJournalObjectIdentifier,
  serverUtility: ServerUtility
): IPromise<ChangeJournalObject[]> {
  return serverUtility
    .getById<ServiceResponse<Machine>>({
      url: "/api/machines/Machine",
      id: changeJournalObjectIdentifier.ObjectId,
    })
    .then((machineResponse): ChangeJournalObject[] => {
      const { Result: machine } = machineResponse;
      const distinctConfigurationTypeObjects = uniqBy(
        (machine.Configs ?? [])
          .map((c) => c.MachineConfigurationType)
          .filter((ct): ct is MachineConfigurationType => !!ct),
        (c) => c.Id
      );
      

      return [
        {
          id: {
            ObjectId: machine.Id,
            ObjectName: machineObjectName,
          },
          object: machine,
        },
        ...(machine.Configs ?? []).map((config) => ({
          id: {
            ObjectId: config.Id,
            ObjectName: machineConfigurationObjectName,
          },
          object: config,
        })),
        ...distinctConfigurationTypeObjects.map<ChangeJournalObject>((ct) => ({
          id: {
            ObjectId: ct.Id,
            ObjectName: machineConfigurationTypeObjectName,
          },
          object: ct,
        })),
      ];
    });
}
